import axios from 'axios';
import { Settings } from './settings';

export async function loadSettings() {
  return (await axios.get<Settings>('/config'))?.data;
}
